import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap pt-3 p-8 pb-0 working-time-box" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex flex-wrap" }
const _hoisted_4 = { class: "working-time-container" }
const _hoisted_5 = { class: "working-time-header" }
const _hoisted_6 = { class: "working-time__desc" }
const _hoisted_7 = { class: "working-time__box" }
const _hoisted_8 = { class: "box-item" }
const _hoisted_9 = { class: "box-item-title" }
const _hoisted_10 = { class: "target-date__time box-item-content" }
const _hoisted_11 = { class: "box-item" }
const _hoisted_12 = { class: "box-item-title" }
const _hoisted_13 = { class: "box-item-content content-table" }
const _hoisted_14 = { class: "content-stat" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_16 = { class: "box-item" }
const _hoisted_17 = { class: "box-item-title" }
const _hoisted_18 = { class: "box-item-content content-table" }
const _hoisted_19 = {
  class: "cursor-pointer text-light-blue underline hover:opacity-75",
  click: "#"
}
const _hoisted_20 = { style: {"font-weight":"bolder"} }
const _hoisted_21 = { style: {"color":"#999999"} }
const _hoisted_22 = { class: "stamp-button flex justify-center mt-8 flex-col" }
const _hoisted_23 = { class: "btn-secondary" }
const _hoisted_24 = { class: "btn-outline-cancel" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('lateEarlyApplication')), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.t('overtimeRegister.targetDate')), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('overtimeRegister.exampleDate')), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.t('workingTimeRegister.leaveTime')), 1),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_Table, {
                  class: "text-center",
                  headers: _ctx.leaveTimeHeader,
                  data: _ctx.leaveTimeData
                }, null, 8, ["headers", "data"]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", null, _toDisplayString(_ctx.t('workingTimeRegister.lateTime')), 1),
                  _createVNode("div", null, _toDisplayString(_ctx.lateTime.checkin), 1),
                  _createVNode("div", null, [
                    _createVNode(_component_Button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleApp('late'))),
                      class: 
                        'content-btn ' +
                        (_ctx.showFlags.late ? 'btn-red' : 'btn-light-blue')
                      
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t(
                          _ctx.showFlags.late
                            ? 'workingTimeRegister.deleteApplication'
                            : 'workingTimeRegister.apply'
                        )), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _hoisted_15,
                  _createVNode("div", null, _toDisplayString(_ctx.t('workingTimeRegister.lateTime')), 1),
                  _createVNode("div", null, _toDisplayString(_ctx.lateTime.break_time), 1),
                  _createVNode("div", null, [
                    _createVNode(_component_Button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleApp('early'))),
                      class: 
                        'content-btn ' +
                        (_ctx.showFlags.early ? 'btn-red' : 'btn-light-blue')
                      
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t(
                          _ctx.showFlags.early
                            ? 'workingTimeRegister.deleteApplication'
                            : 'workingTimeRegister.apply'
                        )), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("p", _hoisted_17, _toDisplayString(_ctx.t('workingTimeRegister.leaveApplication')), 1),
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_Table, {
                  class: "text-center",
                  headers: _ctx.leaveApplicationHeader,
                  data: _ctx.leaveApplicationData
                }, {
                  attach: _withCtx(({ item }) => [
                    _createVNode("a", _hoisted_19, _toDisplayString(item.attach), 1)
                  ]),
                  late_time: _withCtx(({ item }) => [
                    _createVNode("span", _hoisted_20, _toDisplayString(item.late_time), 1)
                  ]),
                  reason: _withCtx(({ item }) => [
                    _createVNode("span", _hoisted_21, _toDisplayString(item.reason), 1)
                  ]),
                  _: 1
                }, 8, ["headers", "data"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("button", _hoisted_23, _toDisplayString(_ctx.t('overtimeRegister.buttonApply')), 1),
            _createVNode("button", _hoisted_24, _toDisplayString(_ctx.t('overtimeRegister.buttonCancel')), 1),
            _hoisted_25
          ])
        ])
      ])
    ])
  ]))
}